import { tc } from 'language/i18nkey';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

type Props = {} & HTMLAttributes<HTMLButtonElement>;
export const CancelBtn = (props: Props) => {
  return <Btn {...props}>{tc('i18n_cancel')}</Btn>;
};

const Btn = styled.button`
  width: 11.2rem;
  height: 4.8rem;
  font-size: 1.6rem;
  font-weight: 700;
  border: 1px solid #c7d6ea;
  //background-color: #123069;
  color: #7783a1;
  border-radius: 10rem;
  line-height: 4.8rem;
`;
